import { Box, TextField, useMediaQuery } from '@mui/material';
import React, { useEffect, useState, useMemo, useCallback } from 'react';

function TextBox({
  icon: Icon,
  name,
  label = 'Input',
  type = 'text',
  required = false,
  maxLength,
  helperText = '',
  externalError,
  externalHelperText,
  errorMessage = 'Valor inválido',
  newValue = '',
  onChange,
  width,
  pattern,
  forceUppercase = false,
}) {
  const isMobile = useMediaQuery("(max-width:768px)");

  // Guardar solo si el valor cambia realmente
  const [value, setValue] = useState(newValue);
  const [error, setError] = useState(false);

  // Solo actualizar si el valor entrante cambia
  useEffect(() => {
    if (newValue !== value) {
      setValue(newValue);
    }
  }, [newValue]);

  // Memoizar regex si existe
  const regex = useMemo(() => pattern ? new RegExp(pattern) : null, [pattern]);

  const handleChange = useCallback((event) => {
    let updatedValue = event.target.value;

    if (forceUppercase) {
      updatedValue = updatedValue.toUpperCase();
    }

    if (maxLength) {
      updatedValue = updatedValue.slice(0, maxLength);
    }

    if (regex) {
      setError(updatedValue && !regex.test(updatedValue));
    }

    setValue(updatedValue);
    onChange?.(name, updatedValue); // solo llama si está definida
  }, [forceUppercase, maxLength, regex, name, onChange]);

  const iconColor = useMemo(() => (value ? 'primary' : 'action.active'), [value]);
  const resolvedError = typeof externalError === 'boolean' ? externalError : error;
  const resolvedHelperText = resolvedError ? (externalHelperText || errorMessage) : helperText;

  return (
    <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
        {Icon && <Icon sx={{ color: iconColor, mr: 1, my: 0.5 }} />}
        <TextField
          id={`input-${name}`}
          label={label}
          variant="standard"
          type={type}
          value={value}
          onChange={handleChange}
          required={required}
          error={resolvedError}
          helperText={resolvedHelperText}
          name={name}
          sx={{ width: isMobile ? 200 : width || 250 }}
          InputLabelProps={{
            shrink: true,
            sx: { transition: 'none' }
          }}
          inputProps={{
            style: { textTransform: forceUppercase ? 'uppercase' : 'none' }
          }}
        />
      </Box>
    </Box>
  );
}

export default React.memo(TextBox);
